import React from "react";

const Animate = () => {
  return (
    <div className=" absolute inset-0 w-full h-full bg-gray-300 animate-pulse "></div>
  );
};

export default Animate;
